// extracted by mini-css-extract-plugin
module.exports = {"lds-facebook":"styles_lds-facebook__9E9Fg"};